/// <reference path="../../../../app.definition.ts" />
import angular from "angular";
import { IConfigService } from "@common/service/config.service";
import { Discussion } from "@common/model/discussion";
import { DiscussionComment } from "@common/model/discussionComment";
import { PopUpService } from "@common/popup/popup.service";

export interface IEcvComment {
    init(): void;
    toggleExpanded(): void;
}

class EcvComment implements IEcvComment {
    post: Discussion;
    comment: DiscussionComment;
    displayedText: string;

    dispComment: String;
    image: string;
    expanded: boolean;
    needsExpanding: boolean;

    static $inject = ["ConfigService", 'PopUpService'];


    constructor(private $config: IConfigService,
            private $_pop: PopUpService,) {
    }

    init(): void {
        this.image = this.comment.sender.photo || this.comment.senderPhoto;

        this.expanded = false;
        // console.log(this.comment.comment);
        // this.dispComment = JSON.parse(this.comment.comment);
        this.needsExpanding =
            !!this.comment &&
            !!this.comment.comment.length &&
            this.comment.comment.length > this.$config.get("commentLength");
    }

    toggleExpanded(): void {
        this.expanded = !this.expanded;
    }

    expand(): void {
        this.expanded = true;
    }

    collapse(): void {
        this.expanded = false;
    }
    
    showModal(event) {
        this.$_pop.openDiscussionPopupOnLinkClick(event);
    }

}

function comment(): ng.IDirective {
    return {
        restrict: "E",
        bindToController: {
            comment: "=ecvCommentObject",
            post: "=ecvPostObject",
        },
        templateUrl:
            "app/common/itemCard/components/comment/comment.directive.html",
        replace: true,
        controller: EcvComment,
        controllerAs: "commentVm",

        link: (
            scope: ng.IScope,
            element: ng.IAugmentedJQuery,
            attributes: ng.IAttributes,
            controller: IEcvComment
        ): void => {
            controller.init();
        },
    };
}

angular.module("eCareVault.common.itemCard").directive("ecvComment", comment);
